import { z } from 'zod';

export const walletSchema = z.object({
	sms_balance: z.number().default(0),
	subscription: z.string().default(''), // string to hold various subscription info
});

export type Wallet = z.infer<typeof walletSchema>;
